import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import SiteLayout from "@/components/site/SiteLayout";
import { useAuth } from "@/lib/auth";
import { toast, Toaster } from "sonner";
import { BRAND } from "@/config/brand";

export default function Signup() {
  const { signup } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const preRef = new URLSearchParams(loc.search).get("ref") || "";
  const [form, setForm] = useState({ email: "", password: "", full_name: "", phone: "", referral_code: preRef });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await signup(form);
      toast.success(`Welcome! $${BRAND.welcomeBonus} welcome bonus credited.`);
      nav("/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Signup failed");
    } finally { setLoading(false); }
  };

  return (
    <SiteLayout>
      <Toaster richColors position="top-center" />
      <section className="section-py container-x max-w-md">
        <h1 className="text-4xl font-extrabold tracking-tight">Get $5 to start.</h1>
        <p className="mt-2 text-muted-foreground">Create your account and unlock the ${BRAND.welcomeBonus} welcome bonus.</p>
        <form onSubmit={submit} className="mt-8 card-soft space-y-4" data-testid="signup-form">
          <div>
            <label className="text-xs font-bold uppercase text-muted-foreground">Full name</label>
            <input data-testid="signup-name" required className="mt-2 w-full rounded-2xl border border-border bg-white px-4 py-3" value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })} />
          </div>
          <div>
            <label className="text-xs font-bold uppercase text-muted-foreground">Email</label>
            <input data-testid="signup-email" type="email" required className="mt-2 w-full rounded-2xl border border-border bg-white px-4 py-3" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          </div>
          <div>
            <label className="text-xs font-bold uppercase text-muted-foreground">Password</label>
            <input data-testid="signup-password" type="password" required minLength={6} className="mt-2 w-full rounded-2xl border border-border bg-white px-4 py-3" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          </div>
          <div>
            <label className="text-xs font-bold uppercase text-muted-foreground">Phone (optional)</label>
            <input data-testid="signup-phone" className="mt-2 w-full rounded-2xl border border-border bg-white px-4 py-3" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
          </div>
          <div>
            <label className="text-xs font-bold uppercase text-muted-foreground">Referral code (optional)</label>
            <input data-testid="signup-ref" className="mt-2 w-full rounded-2xl border border-border bg-white px-4 py-3" value={form.referral_code} onChange={(e) => setForm({ ...form, referral_code: e.target.value })} />
          </div>
          <button data-testid="signup-submit" disabled={loading} className="btn-pill w-full">{loading ? "Creating…" : "Create account"}</button>
        </form>
        <p className="mt-4 text-center text-sm text-muted-foreground">
          Already have an account? <Link to="/signin" className="text-primary font-bold underline">Sign in</Link>
        </p>
      </section>
    </SiteLayout>
  );
}
